import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function PersonIcon({
  className,
  fill = IconColors.Primary,
  height,
  stroke,
  strokeWidth,
  width,
}: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon
      className={className}
      fill="none"
      height={height ?? 24}
      stroke={stroke}
      strokeWidth={strokeWidth}
      viewBoxDimensions="0 0 24 24"
      width={width ?? 24}
    >
      <path
        d="M12 13.5C14.7614 13.5 17 11.2614 17 8.5C17 5.73858 14.7614 3.5 12 3.5C9.23858 3.5 7 5.73858 7 8.5C7 11.2614 9.23858 13.5 12 13.5Z"
        fill={fill}
        stroke={stroke}
      />
      <path
        d="M20 21.5C20 19.3783 19.1571 17.3434 17.6569 15.8431C16.1566 14.3429 14.1217 13.5 12 13.5C9.87827 13.5 7.84344 14.3429 6.34315 15.8431C4.84285 17.3434 4 19.3783 4 21.5"
        fill={fill}
        stroke={stroke}
      />
    </SimpleIcon>
  );
}
